import { formatToMonthDayYear } from "@workspace/lib/date"
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow
} from "@workspace/web-ui/components/table"
  
  export interface PaymentTableProps {
    data: {
      payment_date: string,
      description: string,
      amount: number,
      status: string
    }[]
  }
  
  const PaymentTable = ({ data }: PaymentTableProps) => {
    return (
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Date</TableHead>
            <TableHead>Description</TableHead>
            <TableHead>Amount</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((payment, index) => (
            <TableRow key={index}>
              <TableCell className="font-medium">{formatToMonthDayYear(payment.payment_date)}</TableCell>
              <TableCell>{payment.description}</TableCell>
              <TableCell>${payment.amount}</TableCell>
              <TableCell>
                <span className={`px-2 py-1 rounded-full text-xs ${
                  payment.status === 'paid' ? 'bg-green-100 text-green-500' : 'bg-yellow-100 text-yellow-500'
                }`}>
                  {payment.status}
                </span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    )
  }

  export default PaymentTable